(function(){
    'use strict';
    angular.module('app')
        .controller('UnderMaintenanceController', function() {})
})();



// WEBPACK FOOTER //
// ./js/controllers/UnderMaintenanceController.js